import React from 'react';
import { useTranslation } from 'react-i18next';
import VariantService from '../../../../services/VariantService/VariantService';
import { alertState } from '../../../../recoil-store/recoil-state';
import { useSetRecoilState } from 'recoil';
import './Deploy.css';
/**
 * @Description This function returns Deploy section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Deploy(props) {

    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const setAlert = useSetRecoilState(alertState);

    const handleClick = async () => {
        let user_id;
        try { user_id = JSON.parse(localStorage.getItem('userId')); }
        catch (e) { }
        const res = await VariantService.variantDeploy({ user_id, variants: props.state.variant.first });
        if (res) {
            setAlert(alert => ({ ...alert, show: true, message: t(label + res.message), severity: res.status ? ' success' : 'error' }))
        }
    }
    return (
        <div className="vdeploy">
            <button onClick={handleClick}>{t(label + 'DEPLOY')}</button>
        </div>
    )
}
export default Deploy;